import styled from 'styled-components'

export const Wrapper = styled.div``

export const Fieldset = styled.fieldset`
  padding-right: 30px;
  // display: inline-block;
  position: relative;
  background-color: ${p => p.disabled ? '#eee' : 'inherit'};
  border: ${p => p.error ? `1px solid ${p.theme.colors.border['danger']}` : p.focus ? `1px solid ${p.theme.colors.primary}` : '1px solid #ccc'};
//  border: ${p => `1px solid ${p.focus ? '#85b7d9' : '#eee'}`};
  border-radius: 4px;
  z-index:1;

  &:after {
    content: '';
    display: block;
    position: absolute;
    top: calc(50% - 2px);
    right: 15px;
    border-top: ${p => p.disabled ? '7px solid #bbb' : '7px solid #777'};
    border-right: 7px solid transparent;
    border-left: 7px solid transparent;
    z-index: ${p => p.disabled ? '0' : '-1'};
  }

  &:hover {
    border-color: ${p => !p.disabled && p.theme.colors.primary};

    &:after {
      border-top: ${p => !p.disabled && '7px solid #111'};
    }
  }
`

export const Legend = styled.legend`
  margin-left: 15px;
  margin-bottom: 0;
  padding: ${p => (p.focus || !p.labelSelected) ? '0 4px' : '0'};
  width: auto;
  line-height: 0;
  color: transparent;
  font-size: 0.8rem;
  // transform: scale(0.75);
  font-weight: bold;
`

export const InputSelect = styled.select`
  width: calc(100% + 30px);
  height: 50px;
  opacity: 0;
  cursor: pointer;
`

export const Option = styled.option``

export const Label = styled.label`
  position: absolute;
  top: ${p => (p.focus || !p.labelSelected) ? '-10px' : '13px'};
  left: ${p => (p.focus || !p.labelSelected) ? '19px' : '15px'};
  margin-bottom: 0;
  color: ${p => p.error ? p.theme.colors[p.error] : p.focus ? p.theme.colors.primary : 'rgba(0, 0, 0, 0.5)'};
  font-weight: ${p => (p.focus || p.selectedValue) ? 'bold' : 'normal'};
  font-size: ${p => (p.focus || p.selectedValue) ? '0.8rem' : '1rem'};

//  color: ${p => p.disabled ? '#999' : p.focus ? '#85b7d9' : 'inherit'};
  z-index: ${p => p.disabled ? '0' : '-1'};
  // transform: ${p => (p.focus || !p.labelSelected) ? 'scale(0.75)' : 'scale(1)'};
  transition: all 150ms ease;
`

export const StyledSelect = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  padding-left: 15px;
  z-index: -1;
  background-color: transparent;
`

export const SelectedLabel = styled.div``

export const SubTextWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  min-height: 24px;
`

export const ErrorText = styled.p`
  margin-bottom: 0;
  font-size: 12px;
  color: ${p => p.theme.colors.danger};
`

export const SubLabel = styled.p`
  margin-bottom: 0;
  justify-self: flex-end;
  font-size: 12px;
  text-align: right;
  color: rgba(0, 0, 0, 0.5);
`